<template>
    <div class="event">
        <a :id="event.slug"></a>

        <article>
            <h3>
                <a :href="'/events/' + event.slug" v-text="event.title" />
            </h3>
            <template v-if="event.series.length <= 4">
                <div class="serie" v-for="serie in event.series">
                    <h4 v-text="serie.dateFormatted" />
                    <h4 v-text="serie.timeFormatted" v-if="serie.timeFormatted" />
                    <span class="reserve" v-html="reservationStatusLabel(serie)" />
                </div>
            </template>
            <template v-else>
                <div class="serie">
                    <select
                        class="series"
                        disabled="disabled"
                    >
                        <option
                            v-for="serie in event.series"
                            v-model="serie.hashid"
                            v-text="serie.dateTimeFormatted"
                        />
                    </select>
                </div>
            </template>

            <h4 ossignore v-text="event.location" />
            <div class="body-long" v-html="event.bodyLong" />
            <img
                v-if="event.image"
                :src="event.image.aspect"
                :alt="event.image.alt"
            >
        </article>
    </div>
</template>

<script>
// import {formatDatetimeRange} from '../../_modules/formatDatetimeRange';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isToday from 'dayjs/plugin/isToday'
import {formatDateRange} from '../../_modules/formatDateRange';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(isToday);

export default {
    props: {
        event: {
            type: Object,
            required: true,
        },
        // userIsAdmin: {
        //     type: Boolean,
        //     default: false,
        // },
    },
    
    data: function () {
        return {};
    },

    // computed: {
    //     isUpcoming() {
    //         return dayjs(this.event.dateStart).isSameOrAfter(dayjs());
    //     },
    // },

    methods: {
        formatDateRange,

        reservationStatusLabel(serie) {
            if (!serie.can_reserve) {
                // return 'No registration required.';
                return '';
            } else if (serie.reservations_start && dayjs(serie.reservations_start).isSameOrAfter(dayjs())) {
                if (dayjs(serie.reservations_start).isToday()) {
                    const start = dayjs(serie.reservations_start).format('h:mm a');
                    return `Online reservations open at ${start}.`;
                } else {
                    if (dayjs(serie.reservations_start).format('HH:mm') === '00:00') {
                        const start = dayjs(serie.reservations_start).format('MMMM D, YYYY');
                        return `Online reservations open on ${start}.`;
                    }

                    const startDate = dayjs(serie.reservations_start).format('MMMM D, YYYY');
                    const startTime = dayjs(serie.reservations_start).format('h:mm a');
                    return `Online reservations open on ${startDate} at ${startTime}.`;
                }
                // why support missing reservations_end?
        //     } else if ( (serie.reservations_end && dayjs(serie.reservations_end).isBefore(dayjs()) )
        // || (!serie.reservations_end && serie.dateStart.isBefore(dayjs())) ) {
            } else if (serie.reservations_end && dayjs(serie.reservations_end).isBefore(dayjs())) {
                return 'Online reservations have closed.';
            } else if (serie.spotsAvailable < 1) {
                return `<a href="/reserve/${serie.hashid}" class="cta">Waitlist open.</a>`;
            } else {
                return `<a href="/reserve/${serie.hashid}" class="cta">Reserve now.</a>`;
            }
        },
    },

    created() {
        this.RESERVABILITY_STATUSES = Object.freeze({
            MAY_RESERVE: 1,
            MAY_WAITLIST: 2,
            NOT_ALLOWED: 3,
            WINDOW_FUTURE: 4,
            WINDOW_PAST: 5,
            FULL: 6,
        });
    },
}
</script>

<style lang="scss">
.event {
    .cta {
        font-weight: bold;
    }
    .serie {
        font-size: 100%;
    }
    .body-long {
        font-size: 80%;
    }
}
</style>
